// extracted by mini-css-extract-plugin
module.exports = {"root":"ConfirmModal_root__c5elO","control":"ConfirmModal_control__77DlK"};